import { render, staticRenderFns } from "./FoldingDirectionsScreen.vue?vue&type=template&id=4ed9872a&scoped=true"
import script from "./FoldingDirectionsScreen.vue?vue&type=script&lang=js"
export * from "./FoldingDirectionsScreen.vue?vue&type=script&lang=js"
import style0 from "./FoldingDirectionsScreen.vue?vue&type=style&index=0&id=4ed9872a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed9872a",
  null
  
)

export default component.exports